/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */

window._env_ = window._env_ || {}

console.log('icicle signal server env config', window._env_)

export const signalServerUrl = process.env.SIGNAL_SERVER_URL || window._env_.SIGNAL_SERVER_URL

export const allocateDeviceTimeout =
  process.env.ALLOCATE_DEVICE_TIMEOUT || window._env_.ALLOCATE_DEVICE_TIMEOUT || 30000
